import { render, staticRenderFns } from "./selfTest.vue?vue&type=template&id=3f93692f&scoped=true"
import script from "./selfTest.vue?vue&type=script&lang=js"
export * from "./selfTest.vue?vue&type=script&lang=js"
import style0 from "./selfTest.vue?vue&type=style&index=0&id=3f93692f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93692f",
  null
  
)

export default component.exports